/**
* SEO Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the SEO Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'seo-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.seo-cards' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--seo-cards' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          // gap: '20px',
          autoWidth: true,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'seo-cards', COMPONENT );
} )( app );
